<template>
  <div class="ckeditor">
    <textarea :name="name" :id="id" :value="value" :types="types" :config="config"></textarea>
  </div>
</template>

<script>
let inc = 0
export default {
  props: {
    name: {
      type: String,
      default: () => `editor-${++inc}`
    },
    value: {
      type: String
    },
    id: {
      type: String,
      default: () => `editor-${inc}`
    },
    types: {
      type: String,
      default: () => `classic`
    },
    config: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    instance () {
      /* eslint-disable */
      return CKEDITOR.instances[this.id]
      /* eslint-enable */
    }
  },
  beforeUpdate () {
    if (this.value !== this.instance.getData()) {
      this.instance.setData(this.value)
    }
  },
  mounted () {
    /* eslint-disable */
    if (typeof CKEDITOR === 'undefined') {
      console.log('CKEDITOR is missing (http://ckeditor.com/)')
    } else {
      var config = Object.assign({}, this.config, {extraPlugins: 'divarea'})
      if (this.types === 'inline') {
        CKEDITOR.inline(this.id, config)
      } else {
        CKEDITOR.replace(this.id, config)
      }
      this.instance.on('change', () => {
        let html = this.instance.getData()
        if (html !== this.value) {
          this.$emit('input', html)
        }
      })
    }
    /* eslint-enable */
  },
  beforeDestroy () {
    if (this.instance) {
      setTimeout(() => {
        this.instance.focusManager.blur(true)
        this.instance.removeAllListeners()
        this.instance.destroy()
        this.instance = null
      })
    }
  }
}
</script>
<style>
.ckeditor::after {
  content: "";
  display: table;
  clear: both;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// Ckeditor.vue?5226150a